import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { Table, Spinner, Modal, Button, Form } from 'react-bootstrap';
import RefershIcon from '../../../common/assets/images/reload.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import axiosInstance from '../../../axiosinterceptor';
import axios from 'axios';
import './manageorganization.css';
import { base_URL } from '../../../utils/api';

const ManageOrganization = () => {
    const navigate = useNavigate();
    const permissions = JSON.parse(sessionStorage.getItem('permissions'));

    useEffect(() => {
        if (permissions && !permissions.admin) {
            navigate('/no-access');
        }
    }, [permissions, navigate]);

    const [organizations, setOrganizations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [editingOrg, setEditingOrg] = useState(null);
    const [organizationName, setOrganizationName] = useState('');
    const [deletingOrg, setDeletingOrg] = useState(null);
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        const fetchOrganizations = async () => {
            setIsLoading(true);
            try {
                const response = await axiosInstance.get("/getAdminOrganizationsACS");
                if (response.data && Array.isArray(response.data.data)) {
                    setOrganizations(response.data.data);
                } else {
                    setOrganizations([]);
                }
            } catch (error) {
                // console.error('Error fetching organizations:', error);
                toast.error(error.response?.data?.message || "Error fetching organizations.");
                
            }
            setIsLoading(false);
        };
        fetchOrganizations();
    }, [refresh]);

    const handleShowModal = (org = null) => {
        setEditingOrg(org);
        setOrganizationName(org ? org.organization_name : '');
        setShowModal(true);
    };

    const handleSave = async () => {
        if (!organizationName.trim()) {
            toast.error('Organization name cannot be empty!');
            return;
        }

        const isDuplicate = organizations.some(
            (org) =>
                org.organization_name.toLowerCase() === organizationName.toLowerCase() &&
                (!editingOrg || org.organization_id !== editingOrg.organization_id)
        );

        if (isDuplicate) {
            toast.error('Organization name already exists!');
            return;
        }

        if (editingOrg) {
            try {
                const response=  await axiosInstance.put(`/updateAdminZOrganizations`, {
                    neworganizationName: organizationName,
                    organizationId: editingOrg.organization_id,
                });
                toast.success(response.data.message);
                // toast.success('Organization updated successfully');
                setOrganizations((prev) =>
                    prev.map((org) =>
                        org.organization_id === editingOrg.organization_id ? { ...org, organization_name: organizationName } : org
                    )
                );
            } catch (error) {
                // console.error('Error updating organization:', error);
                // toast.error('Failed to update organization');
                toast.error(error.response?.data?.message || "Failed to update organization.");

            }
        } else {
            try {
                const response =  await axiosInstance.post('/PostAdminOrganizations', {
                    organizationName: organizationName,
                });
                // toast.success('Organization added successfully');
                toast.success(response.data.message);
                setRefresh(!refresh);
            } catch (error) {
                // console.error('Error adding organization:', error);
                // toast.error('Failed to add organization');
                toast.error(error.response?.data?.message || "Failed to add organization.");

            }
        }

        setShowModal(false);
        setRefresh(!refresh);
    };

    const handleShowDeleteModal = (org) => {
        setDeletingOrg(org);
        setShowDeleteModal(true);
    };

    const handleDelete = async () => {
        if (!deletingOrg) return;

        try {
            const response =  await axiosInstance.delete(`/DeleteAdminOrganizations?organizationId=${deletingOrg.organization_id}`);
            // toast.success(`Organization "${deletingOrg.organization_name}" deleted successfully`);
            toast.success(response.data.message);
            setOrganizations((prev) => prev.filter((org) => org.organization_id !== deletingOrg.organization_id));
        } catch (error) {
            // console.error('Error deleting organization:', error);
            // toast.error('Failed to delete organization');
            toast.error(error.response?.data?.message || "Failed to delete organization.");

        }

        setShowDeleteModal(false);
        setRefresh(!refresh);
    };

    const handleRefresh = () => {
        setRefresh(!refresh);
    };
    useEffect(() => {
      return () => {
        toast.dismiss();
      };
    }, []);
    return (
        <div className="userlist-section">
            <ToastContainer autoClose={5000} />
             <p
                    className="userlist-back-btn"
                    onClick={() => navigate("/admin")}
                >
                   « Back
                </p>
            <div className="userlist-header">
               
                <h4 className="userlist-header-text">Organizations </h4>
                <div className="userlist-filter-section">
                    <button className="userlist-filter-btn" onClick={() => handleShowModal()}>
                        Add Organization
                    </button>
                    <span className="userlist-refresh-btn" onClick={handleRefresh}>
                        <span>
                            <img src={RefershIcon} alt="Refresh" />
                        </span>
                    </span>
                </div>
            </div>
            <div className="userlist-table-container">
                <Table responsive="sm" style={{ textAlign: 'center' }} className="userlist-filter-table">
                    <thead className="userlist-thead">
                        <tr className="userlist-tr">
                            <th className="userlist-th">Organization ID</th>
                            <th className="userlist-th">Organization Name</th>
                            <th className="userlist-th">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="3">
                                    <div className="userlist-table-loader">
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        ) : organizations && organizations.length > 0 ? (
                            organizations.map((org) => (
                                <tr key={org.organization_id}>
                                    <td className="userlist-td">{org.organization_id}</td>
                                    <td className="userlist-td">{org.organization_name}</td>
                                    <td className="userlist-td">
                                        <FontAwesomeIcon
                                            icon={faPenToSquare}
                                            className="iconuser-update"
                                            onClick={() => handleShowModal(org)}
                                        />
                                        <FontAwesomeIcon
                                            icon={faTrash}
                                            className="iconuser-update"
                                            onClick={() => handleShowDeleteModal(org)}
                                        />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3">
                                    <p className="mb-0">No Records Found</p>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{editingOrg ? 'Edit Organization' : 'Add Organization'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group>
                            <Form.Label>Organization Name:</Form.Label>
                            <Form.Control
                                type="text"
                                value={organizationName}
                                onChange={(e) => setOrganizationName(e.target.value)}
                                placeholder="Organization Name"
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={handleSave}>
                        {editingOrg ? 'Update' : 'Save'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete the organization "<b>{deletingOrg?.organization_name}</b>"?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="success" onClick={handleDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ManageOrganization;